import { logError } from '@/src/logger';
import { track } from '@/src/utils/tracking';
import { getScreenName } from './utilsTracking';

const filterClicked = (
  businessType,
  shopFilteringSelected,
  landingType,
  isItemLanding = false,
) => {
  const EVENT_NAME = 'filter.clicked';

  try {
    const payload = {
      businessType,
      shopFilteringSelected,
      origin: 'shop_list',
      screenName: getScreenName(landingType),
      screenType: isItemLanding ? 'items_landing' : 'vendors_landing',
    };
    track(EVENT_NAME, payload, {
      logEventKey: `[${EVENT_NAME}]`,
      sendToLogs: true,
    });
  } catch (e) {
    logError(EVENT_NAME, e);
  }
};

export default filterClicked;
